export default __webpack_public_path__ + "static/media/presentation.d0bda530.pptx";